<div class="main-content" [ngClass]="{'modelling': isModellingOnPage }">
    <div class="px-mb-20">
        <span class="title2" *ngIf="!loadingLowestWccr">LOWEST WCCR</span>
        <span class="title2" *ngIf="loadingLowestWccr">Loading, Please wait...</span>
        <div class="d-flex flex-row flex-wrap px-mt-10" *ngIf="!loadingLowestWccr">
            <app-wccr-box boxTitle="<100%" boxClass="gray-box" *ngIf="!lessThan100List || lessThan100List.length === 0"
                class="px-me-20">
            </app-wccr-box>
            <app-wccr-box *ngFor="let item of lessThan100List; let isFirst = first; let isLast = last;"
                boxClass="red-box" [boxTitle]="isFirst ? '<100%' : ''" [ccr]="item"
                [ngClass]="(isLast) ? 'px-me-20' : 'px-me-5'">
            </app-wccr-box>

            <app-wccr-box boxTitle="100-200%" boxClass="gray-box"
                *ngIf="!between100And200List || between100And200List.length === 0" class="px-me-20">
            </app-wccr-box>
            <app-wccr-box *ngFor="let item of between100And200List; let isFirst = first; let isLast = last;"
                boxClass="yellow-box" [boxTitle]="isFirst ? '100-200%' : ''" [ccr]="item"
                [ngClass]="(isLast) ? 'px-me-20' : 'px-me-5'">
            </app-wccr-box>

            <app-wccr-box boxTitle="200-300%" boxClass="gray-box"
                *ngIf="!between200And300List || between200And300List.length === 0" class="px-me-20">
            </app-wccr-box>
            <app-wccr-box *ngFor="let item of between200And300List; let isFirst = first; let isLast = last;"
                boxClass="lime-box" [boxTitle]="isFirst ? '200-300%' : ''" [ccr]="item"
                [ngClass]="(isLast) ? 'px-me-20' : 'px-me-5'">
            </app-wccr-box>

            <app-wccr-box boxTitle="300+%" boxClass="gray-box" *ngIf="!plus300List || plus300List.length === 0"
                class="px-me-20">
            </app-wccr-box>
            <app-wccr-box *ngFor="let item of plus300List; let isFirst = first; let isLast = last;"
                [boxTitle]="isFirst ? '300+%' : ''" [ccr]="item" [ngClass]="(isLast) ? 'px-me-20' : 'px-me-5'">
            </app-wccr-box>
        </div>
    </div>

    <div class="px-mb-20">
        <div class="card">
            <div class="card-header table-card-header d-flex flex-row">
                <div class="me-auto">
                    10 LOWEST CCRs
                </div>
                <div class="dropdown dropstart">
                    <div id="lowestCcrDownloadDropdownMenu" class="logo-btn-small download dropdown-toggle"
                        role="button"></div>
                    <div class="dropdown-download">
                        <button class="dropdown-item" (click)="onLowestCcrExport()">
                            Download CSV
                        </button>
                    </div>
                </div>
            </div>
            <div class="ag-fresh tenLowestCcrGrid">
                <ag-grid-angular
                    [rowData]="tenLowestWccrsWithShock" 
                    [columnDefs]="lowestWccrColumnDef" 
                    [domLayout]="domLayout"
                    [gridOptions]="lowestWccrGridOptions" 
                    [overlayLoadingTemplate]="overlayLoadingTemplate"
                    [overlayNoRowsTemplate]="overlayNoRowsTemplate" 
                    [suppressRowDeselection]="true"
                    (gridReady)="onLowestWccrGridReady($event)">
                </ag-grid-angular>
            </div>
            
        </div>
    </div>

    <div>
        <div class="card">
            <div class="card-header table-card-header d-flex flex-row">
                <div class="me-auto">
                    LEGAL ENTITY & COUNTERPARTY SUMMARY
                </div>
                <div class="dropdown dropstart">
                    <div id="summaryDownloadDropdownMenu" class="logo-btn-small download dropdown-toggle" role="button">
                    </div>
                    <div div class="dropdown-download">
                        <button class="dropdown-item" (click)="onSummaryExport()">
                            Download CSV
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-header table-card-header d-flex grid-control-bar  flex-row">
                <div class="me-auto">
                    <div class="bnpp-btn-group btn-group btn-group-toggle" role="group"  name="radioBasic"
                    >

                    <input type="radio" [(ngModel)]="isWCCRTableSelected" (ngModelChange)="onTableSelection($event)" name="btnradio"
                    [value]='true' class="btn-check" id="wccr" autocomplete="off">
                   <label class=" btn" [ngClass]="isWCCRTableSelected ? 'active':''" for="wccr">WCCR</label>
                   <input type="radio" [(ngModel)]="isWCCRTableSelected" (ngModelChange)="onTableSelection($event)" name="btnradio"
                    [value]='false' class="btn-check" id="exposure" autocomplete="off">
                   <label class=" btn" [ngClass]=" !isWCCRTableSelected  ? 'active':''" for="exposure">Exposure</label>

                        <!--<label ngbButtonLabel>
                            <input ngbButton type="radio" [value]="true"> WCCR
                        </label>
                        <label class="ms-2" ngbButtonLabel>
                            <input ngbButton type="radio" [value]="false"> Exposure
                        </label>-->
                    </div>
                    <span class="bnpp-regular px-ms-20 ms-2" *ngIf="!isWCCRTableSelected">Legal Entities: </span>
                    <div class="bnpp-btn-group btn-group btn-group-toggle" ngbRadioGroup name="radioBasic"
                         *ngIf="!isWCCRTableSelected" role="group">

                        <input type="radio" [checked]="showLegalEntity === true" (change)="toggleShowLegalEntity(true)" name="btnradio"
                         [value]='true' class="btn-check" id="show" autocomplete="off">
                        <label class=" btn" [ngClass]=" showLegalEntity  ? 'active':''" for="show">Show</label>
                         <input type="radio" [checked]="showLegalEntity === false" (change)="toggleShowLegalEntity(false)" name="btnradio"
                         [value]='false' class="btn-check" id="hide" autocomplete="off">
                        <label class=" btn" [ngClass]=" !showLegalEntity  ? 'active':''" for="hide">Hide</label>


                        <!--<label ngbButtonLabel>
                            <input ngbButton type="radio" [value]="true"> Show
                        </label>
                        <label ngbButtonLabel>
                            <input ngbButton type="radio" [value]="false"> Hide
                        </label>-->
                    </div>
                </div>

                <div class=" my-2 my-lg-0 form-inline  ">
                    <input class="form-control me-sm-2 form-control-sm grid-filter" type="search" placeholder="Search"
                        [(ngModel)]="allCcrTableSearchText" aria-label="Search">
                </div>
            </div>


            <div class="ag-fresh angular_grid_style">
                <ag-grid-angular [quickFilterText]="allCcrTableSearchText"
                    [columnDefs]="legalEntityCounterpartySummaryColumnDef"
                    [rowData]="legalEntityCounterpartySummaryRowData"
                    [gridOptions]="legalEntityCounterpartySummaryGridOption" [domLayout]="domLayout"
                    [pinnedBottomRowData]="pinnedBottomRowData" [overlayLoadingTemplate]="overlayLoadingTemplate"
                    [overlayNoRowsTemplate]="overlayNoRowsTemplate" [suppressRowDeselection]="true"
                    (gridReady)="onSummaryGridReady($event)">
                </ag-grid-angular>
            </div>
        </div>
    </div>
</div>